import axios from 'axios';
let aborts = [];

const client = axios.create({
  baseURL: process.env.REACT_APP_BRASPAG_URL,
});

client.interceptors.request.use((opts) => {
  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/x-www-form-urlencoded',
  };
  const apiConfig = {
    ...opts,
    headers,
    cancelToken: new axios.CancelToken(function (c) {
      aborts.push(c);
    }),
  };
  return apiConfig;
});

client.interceptors.response.use(
  (response) => response,
  (error) => {
    const data = error.response !== undefined ? error.response.data : error;
    return Promise.reject(data);
  },
);

export const cancel = () => {
  aborts.forEach((abort) => abort());
  aborts = [];
};

export const isCancel = (err) => {
  axios.isCancel(err);
};

export default () => client;
export const get = client.get.bind(client);
export const put = client.put.bind(client);
export const post = client.post.bind(client);
